module.exports = __webpack_public_path__ + "img/image-04.86f08726.jpg";